import type { SelecionarLocalStepProps } from "./types-selecionar-local-step";
import { useSelecionarLocalStep } from "./use-selecionar-local-step";
import { SelecionarLocalStepView } from "./view-selecionar-local-step";

export function SelecionarLocalStep(props: SelecionarLocalStepProps) {
  const vm = useSelecionarLocalStep(props);

  return <SelecionarLocalStepView {...vm} />;
}

export type * from "./types-selecionar-local-step";
